import moment from "moment";
function numberOfNightsBetweenDates(startDate, endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);
    let dayCount = 0;

    while (end > start) {
        dayCount++;
        start.setDate(start.getDate() + 1);
    }

    return dayCount;
}
function checkIsValidDatePayment(startDate, endDate) {
    const dateFrom = moment(startDate);
    const dateTo = moment(endDate);
    const diffFromAndTo = dateTo.diff(dateFrom, "days");
    const diffFromAndNow = dateFrom.diff(moment(), "days");
    return diffFromAndTo > 0 && diffFromAndNow >= 0;
}

function formatBookDate(date) {
    const dateMoment = moment(date).format("YYYY-MM-DD");
    return dateMoment;
}
export { numberOfNightsBetweenDates, checkIsValidDatePayment, formatBookDate };
